export const SPIDER_BOSS_FLOOR = 4;
export const SPIDER_BOSS_MAP_SIZE = 30;
export const SPIDERWEB_COUNT = 64;
export const SPIDER_BOSS_SIGHT_DIAMETER = 7;
export const SPIDER_BOSS_ENEMY_ID = 'nested_horror';
export const SPIDERWEB_SHAKE_DURATION_MS = 520;

export function isSpiderBossFloor(floor) {
  return Math.max(1, Math.floor(Number(floor) || 1)) === SPIDER_BOSS_FLOOR;
}

export function getSpiderBossFloorMood() {
  return {
    id: 'spider-boss-floor',
    name: 'Webbed Floor',
    tilesetId: 'default',
    mapSize: { mode: 'fixed', value: SPIDER_BOSS_MAP_SIZE },
    torchDuration: {
      mode: 'default',
      value: 80,
    },
    layout: {
      preset: 'colossal',
      forceSingleRoom: true,
      noCorridors: true,
      roomSizeMultiplier: 2.55,
      roomCountMultiplier: 0.1,
      corridorDensityMultiplier: 0.0,
      corridorLengthMultiplier: 0.0,
      deadEndMultiplier: 0.0,
    },
    counts: {
      enemyMultiplier: 0,
      trapMultiplier: 1.1,
      brazierMultiplier: 1.15,
      restMultiplier: 1.0,
      chestMultiplier: 1.2,
      chestFlatBonus: 2,
      simpleChestCount: 1,
      loreMultiplier: 1.3,
      shopMultiplier: 0,
      lockedDoorMultiplier: 0,
      lockedDoorFlatBonus: 0,
      storylineMultiplier: 1.25,
      statueMultiplier: 0,
      statueFlatBonus: 0,
      statueSpawnChance: 0,
    },
  };
}
